import React, {Fragment, useEffect} from 'react';
import styled from 'styled-components';
import I18n from 'i18n-js';
import * as PropTypes from 'prop-types';
import colors from '../../../lib/Colors';
import fonts from '../../../lib/Fonts';
import ExternalLink from '../../shared/ExternalLink'

const SupportProposalLabel = styled.h2`
  font-size: 1.75em;
  color: ${colors.almostBlack};
  font-family: ${fonts.family.workSans};
  margin: 0 0 1em;
  font-weight: 300;
`;

const SupportProposalLabelMessage = styled.p`
  font-family: ${fonts.family.workSans};
  font-size: 1em;
  line-height: 1.4;
  color: ${colors.colorDefaultheaderText};
`;

const SupportProposal = ({resetState}) => {

  useEffect(() => {
    return () => {
      resetState();
    };
  }, []);

  return (
    <Fragment>
      <SupportProposalLabel>{I18n.t('shared.supportProposalLabel')}</SupportProposalLabel>
      <SupportProposalLabelMessage>{I18n.t('shared.supportProposalMessage')}</SupportProposalLabelMessage>
      <ExternalLink href='mailto:support@bevspot.com'>{I18n.t('shared.supportEmailAddress')}</ExternalLink>
    </Fragment>
  )
};

SupportProposal.propTypes = {
  resetState: PropTypes.func
};

export default SupportProposal;
